<div
  class="toastr border border-gray-200 rounded-lg bg-gray-300 flex items-start gap-5 justify-between px-4 py-3 w-full max-w-96 mb-2">
  <div class="flex items-start gap-2">
    <div class="icon rounded-lg p-1 w-6 h-6 mask mask-squircle flex items-center justify-center">
      @if (toastClasses.includes('error')) {
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
          <path d="m5.25 5 14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"/>
          <path d="M22.25 12c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10Z"
                stroke="currentColor" stroke-width="1.5"/>
        </svg>
      } @else if (toastClasses.includes('info')) {

      } @else if (toastClasses.includes('success')) {
        <svg class="pl-0.5" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
          <path d="m5 14 3.5 3.5L19 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      } @else if (toastClasses.includes('warning')) {

      }
    </div>
    <div class="flex flex-col">
      @if (title) {
        <div class="font-semibold">{{ title }}</div>
      }
      @if (message) {
        <div class="text-sm">{{ message }}</div>
      }
    </div>
  </div>

  <button class="cursor-pointer" (click)="remove()">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
      <path d="M19 5 5 19M5 5l14 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>
  </button>
</div>
